import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the page scroll to (0, 0) on every route change.
 *
 * React Router preserves scroll position across pushes by default, which is
 * fine for back/forward but feels broken when clicking forward links — the
 * new page lands at whatever offset the previous one had.
 *
 * Mount this once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use "instant" so it doesn't conflict with any in-page anchor scrolls.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
